import flagData from '../featureFlags.json';

const FEATURE_FLAGS = Object.fromEntries(
  Object.entries(flagData).map(([key, flag]) => [key, flag.active]),
) as Record<keyof typeof flagData, boolean>;

export { FEATURE_FLAGS };
